import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import { sendContact } from '../actions/contact'
import { error as logError } from "../logger";
import { Helmet } from "react-helmet";
import VersionComponent from './VersionComponent.jsx'

import squareLeftBackground from '../img/v1/home/squareLeftBackground.png'
import squareRightBackground from '../img/v1/home/squareRightBackground.png'

import emailIcon from "../img/v1/contact/email.svg"
import messageIcon from "../img/v1/contact/message.svg"
import subjectIcon from "../img/v1/contact/subject.svg"
import phoneIcon from "../img/v1/contact/phone.svg"
import nameIcon from "../img/v1/contact/name.svg"

import blueLeftBackground from '../img/v2/home/blueLeftBackground.png'
import blueRightBackground from '../img/v2/home/blueRightBackground.png'
import emailIconV2 from "../img/v2/contact/email.png"
import messageIconV2 from "../img/v2/contact/message.png"
import phoneIconV2 from "../img/v2/contact/phone.png"
import nameIconV2 from "../img/v2/contact/name.png"

import "../scss/v2/contact.scss"

function Contact(props) {

    const { t, i18n } = useTranslation();
    const [name, setName] = useState(null)
    const [firstName, setFirstName] = useState(null)
    const [email, setEmail] = useState(null)
    const [phone, setPhone] = useState(null)
    const [subject, setsubject] = useState(null)
    const [message, setMessage] = useState(null)
    const [pending, setPending] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        i18n.changeLanguage(props.lang);
    }, [i18n, props.lang])

    const submitHandler = (event) => {
        event.preventDefault();
        setPending(true)
        setSuccess(false)
        setError(false)

        const contactDetails = {
            lastName: name,
            firstName,
            email,
            phone,
            subject,
            content: message,
            url: window.location.href,
        }

        if (!contactDetails.email || !contactDetails.subject || !contactDetails.content || !contactDetails.lastName || !contactDetails.phone) {
            setError('field')
            setPending(false)
            return;
        }

        props.dispatch(sendContact(contactDetails))
        .then(() => {
            setPending(false);
            setSuccess(true);
            setEmail(null);
            setName(null);
            setPhone(null);
            setsubject(null);
            setName(null);
        })
        .catch(err => {
            if (!err.statusCode || err.statusCode >= 500) logError(err);
            setPending(false)
            setError("generic")
        })
    }

    function renderSubmit() {
        if (success) return;
        if (pending) return (
            <div className="d-flex justify-content-center mb-4">
                <div className="spinner-border" role="status">
                    <span className="sr-only">{t('loading')}</span>
                </div>
            </div>
        )

        return (
            <button className="button ornage-button contact-card-submit-button">{t('contact.card.submit')}</button>
        );
    }

    function renderMessage() {
        if(error) {
            return (
                <div className='alert alert-danger mb-3' >{t(`contact.message.error.${error}`)}</div>
            )
        } else if(success){
            return (
                <div className='alert alert-success mb-3' >{t('contact.message.success')}</div>
            )
        }
        return;
    }

    return (
        <div className="contact">
            <Helmet>
                <title>{t("meta.title.contact")}</title>
                <meta name="description" content={t("meta.description.contact")} />
            </Helmet>
            <div className="container">
                <div className="square-background">
                    <VersionComponent desiredVersion="v1">
                        <img className="img img-fluid left-square-background" src={squareLeftBackground} alt={squareLeftBackground} />
                    </VersionComponent>
                    <VersionComponent desiredVersion="v2">
                        <img className="img img-fluid left-square-background" src={blueLeftBackground} alt={blueLeftBackground} />
                    </VersionComponent>
                    <div className="square-bakground-content">
                        <div className="row">
                            <div className="col-12 col-lg-8 offset-lg-2">
                                <div className="contact-card">
                                    <h1 className="contact-card-title">{t('contact.card.title')}</h1>
                                    {renderMessage()}
                                    <form id="contact-form" className="row" onSubmit={submitHandler} >
                                        <div className="col-12 col-lg-6">
                                            <div className={`contact-card-input-group${error === "field" ? ' error' : ''}`}>
                                                <p className="contact-card-input-group-label">{t('contact.card.label.name')}</p>
                                                <input className="contact-card-input-group-input" placeholder={t('contact.card.placeholder.name')} onChange={(event) => { setName(event.target.value) }} />
                                                <div className="contact-card-input-group-left-icon">
                                                    <VersionComponent desiredVersion="v1">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={nameIcon} alt={nameIcon} />
                                                    </VersionComponent>
                                                    <VersionComponent desiredVersion="v2">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={nameIconV2} alt={nameIconV2} />
                                                    </VersionComponent>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className="contact-card-input-group">
                                                <p className="contact-card-input-group-label">{t('contact.card.label.firstName')}</p>
                                                <input className="contact-card-input-group-input" placeholder={t('contact.card.placeholder.firstName')} onChange={(event) => { setFirstName(event.target.value) }} />
                                                <div className="contact-card-input-group-left-icon">
                                                    <VersionComponent desiredVersion="v1">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={nameIcon} alt={nameIcon} />
                                                    </VersionComponent>
                                                    <VersionComponent desiredVersion="v2">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={nameIconV2} alt={nameIconV2} />
                                                    </VersionComponent>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className={`contact-card-input-group${error === "field" ? ' error' : ''}`}>
                                                <p className="contact-card-input-group-label">{t('contact.card.label.email')}</p>
                                                <input className="contact-card-input-group-input" placeholder={t('contact.card.placeholder.email')} onChange={(event) => { setEmail(event.target.value) }} />
                                                <div className="contact-card-input-group-left-icon">
                                                    <VersionComponent desiredVersion="v1">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={emailIcon} alt={emailIcon} />
                                                    </VersionComponent>
                                                    <VersionComponent desiredVersion="v2">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={emailIconV2} alt={emailIconV2} />
                                                    </VersionComponent>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className={`contact-card-input-group${error === "field" ? ' error' : ''}`}>
                                                <p className="contact-card-input-group-label">{t('contact.card.label.phone')}</p>
                                                <input className="contact-card-input-group-input" placeholder={t('contact.card.placeholder.phone')} onChange={(event) => { setPhone(event.target.value) }} />
                                                <div className="contact-card-input-group-left-icon">
                                                    <VersionComponent desiredVersion="v1">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={phoneIcon} alt={phoneIcon} />
                                                    </VersionComponent>
                                                    <VersionComponent desiredVersion="v2">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={phoneIconV2} alt={phoneIconV2} />
                                                    </VersionComponent>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <h2 className="contact-card-subtitle">{t('contact.card.subtitle')}</h2>
                                        </div>
                                        <div className="col-12">
                                            <div className={`contact-card-input-group${error === "field" ? ' error' : ''}`}>
                                                <p className="contact-card-input-group-label">{t('contact.card.label.subject')}</p>
                                                <input className="contact-card-input-group-input" placeholder={t('contact.card.placeholder.subject')} onChange={(event) => { setsubject(event.target.value) }} />
                                                <div className="contact-card-input-group-left-icon">
                                                    <VersionComponent desiredVersion="v1">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={subjectIcon} alt={subjectIcon} />
                                                    </VersionComponent>
                                                    <VersionComponent desiredVersion="v2">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={messageIconV2} alt={messageIconV2} />
                                                    </VersionComponent>
                                                </div>
                                            </div>
                                            <div className={`contact-card-input-group${error === "field" ? ' error' : ''}`}>
                                                <p className="contact-card-input-group-label">{t('contact.card.label.message')}</p>
                                                <textarea className="contact-card-input-group-input contact-card-input-group-textarea" placeholder={t('contact.card.placeholder.message')} onChange={(event) => { setMessage(event.target.value) }} />
                                                <div className="contact-card-input-group-left-icon">
                                                    <VersionComponent desiredVersion="v1">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={messageIcon} alt={messageIcon} />
                                                    </VersionComponent>
                                                    <VersionComponent desiredVersion="v2">
                                                        <img className="img img-fluid contact-card-input-group-left-icon-svg" src={messageIconV2} alt={messageIconV2} />
                                                    </VersionComponent>
                                                </div>
                                            </div>
                                            {renderSubmit()}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <VersionComponent desiredVersion="v1">
                        <img className="img img-fluid right-square-background" src={squareRightBackground} alt={squareRightBackground} />
                    </VersionComponent>
                    <VersionComponent desiredVersion="v2">
                        <img className="img img-fluid right-square-background" src={blueRightBackground} alt={blueRightBackground} />
                    </VersionComponent>
                </div>
            </div>
        </div>
    )

}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Contact)